/**
 * @file notification.class.js
 * @description Defines the Notification class.
 */

class NotificationBanner {
  constructor(debug = false) {
    this.elNotificationBannerBottom = Helper.getElement('.notification-banner--bottom');
    if (!this.elNotificationBannerBottom) return;
    this.data = {
      persistResponse: this.elNotificationBannerBottom.dataset.persistResponse !== null ? this.elNotificationBannerBottom.dataset.persistResponse : false
    }
    if (this.data.persistResponse && window.sessionStorage.getItem('isNotificationBannerClosed') === "true") {
      if (this.elNotificationBannerBottom) {
        this.elNotificationBannerBottom.parentNode.removeChild(this.elNotificationBannerBottom);
      }
      return;
    }
    this.elFooter = Helper.getElement('footer.footer');
    this.init();
    this.debug();
  }

  init() {
    if (this.elNotificationBannerBottom) {
      this.initFooter();
      this.bindEvents();
    }
  }

  /**
   * @description Initialize the footer. Add a bottom margin based on the notification's height
   * ony if the notification is sticky.
   */
  initFooter() {
    if (this.elNotificationBannerBottom) {

      let isSticky = this.elNotificationBannerBottom.hasAttribute('data-sticky');

      if (isSticky) {
        let marginBottom = this.elNotificationBannerBottom.clientHeight;
        this.elFooter.style.marginBottom = marginBottom + 'px';
      } else {
        this.elFooter.style.marginBottom = 0;
      }
    }
  }

  bindEvents() {
    if (this.elNotificationBannerBottom) {
      let elClose = this.elNotificationBannerBottom.querySelector('[data-banner-close]');
      elClose.addEventListener('click', event => { this.handleClose(event) });
      elClose.addEventListener('touch', event => { this.handleClose(event) });
    }
  }

  /**
   * @descriptionm Handle banner close click / touch events.
   * @param {event} event 
   */
  handleClose(event) {
    //event.returnValue = false;  // IE 11 Fix.
    event.preventDefault();
    let elNotificationBanner = event.target.closest('.notification-banner');
    elNotificationBanner.parentNode.removeChild(elNotificationBanner);
    window.sessionStorage.setItem('isNotificationBannerClosed', "true");
    this.initFooter();
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c NotificationBanner', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}